import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.2 18.85c.2.19.51.19.71 0l6-6c.2-.2.2-.51 0-.71s-.51-.2-.71 0l-5.15 5.15V1.5c0-.28-.23-.5-.5-.5s-.5.22-.5.5v15.79l-5.14-5.15c-.2-.2-.51-.2-.71 0s-.2.51 0 .71l6 6z',
  ],
  height: 20,
  width: 20,
});
